import React from 'react'
import { translateNode } from 'src/localization/translateNode'

export const fileIsEmpty = (val?: File): React.ReactElement | undefined =>
  val === undefined ? translateNode('Must not be blank') : undefined
